import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ classModifier, styleModifier, ...props }) => {
  return (
    <div style={styleModifier}
      className={classModifier ? `Card--${classModifier}` : 'Card'}>
      {props.children}
    </div>
  );
};

Card.propTypes = {
  classModifier: PropTypes.oneOf([
    'default',
    'darkenBackground',
    'dashboardMenu',
    'yellowBackground',
  ]),
  children: PropTypes.node,
  styleModifier: PropTypes.object,
};

export { Card };